export const addresses = {
  pt: 'Estr. da Circunvalação, <br>10748 B 1.1<br>4460-280, Matosinhos<br><b>Portugal</b>',
  es: 'C/ Santiago Grisolía nº 2<br>28760 Tres Cantos, Madrid<br><b>España</b>',
  fr: undefined,
  uk: undefined,
};
export const phones = {
  pt: '+351 220 327 775',
  es: '+34 911 23 59 00',
  fr: '+33 1 76 44 05 62',
  uk: '+44 2046 006762',
};
export const emails = {
  pt: 'geral@b-parts.com',
  es: 'hola@b-parts.com',
  de: 'hallo@b-parts.com',
  fr: 'bonjour@b-parts.com',
};

export const nif = 'PT 510 824 625';

export const contactsSubject = [
  {
    key: 'How to shop',
    trans: 'contacts.form.select_subject.options.purchases',
  },
  {
    key: 'Product information',
    trans: 'contacts.form.select_subject.options.product_info',
  },
  {
    key: 'Tracking my order',
    trans: 'contacts.form.select_subject.options.tracking',
  },
  {
    key: 'Returns',
    trans: 'contacts.form.select_subject.options.returns',
  },
  {
    key: 'Other',
    trans: 'contacts.form.select_subject.options.other',
  },
];
